module.exports = __webpack_public_path__ + "static/media/left_menu.c4dc1c71.png";